var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.paymentsWithDeadlineToDisplay.length > 0
        ? _c("h3", [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$l10n.__("Liste des paiements liés à des échéances")
                ) +
                "\n    "
            )
          ])
        : _c("h3", [
            _vm._v(_vm._s(_vm.$l10n.__("Ajouter un nouveau règlement")))
          ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "aright" },
        [
          _vm.hasReconciledPayment
            ? _c("CompassButton", {
                attrs: { label: _vm.wordingBtnCollapse, type: "tertiary" },
                on: { click: _vm.togglePaymentsDisplay }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.paymentsWithDeadlineToDisplay.length > 0,
              expression: "paymentsWithDeadlineToDisplay.length > 0"
            }
          ],
          class: {
            "b-1 br": true,
            "br-bottom-0": _vm.paymentsToAdd.length > 0
          },
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.paymentsWithDeadlineToDisplay,
            "row-key": _vm.rowKey
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date"), width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("saasDateFormatted")(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ref", label: _vm.$t.__("common.labels.reference") }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.labels.payment_amount"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("numberformatCurrency")(scope.row.amount)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.labels.payment_status"),
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.payStepLabel !== undefined
                      ? _c("div", [
                          _c("div", {
                            class: "chip chip-" + scope.row.payStepChip
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(scope.row.payStepLabel) +
                              "\n                "
                          )
                        ])
                      : _c("div", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$l10n.__("Nouveau paiement")) +
                              "\n                "
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "bankreconciliation.DeadlineListing.related_deadline"
              ),
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          width: "200",
                          trigger: "hover"
                        }
                      },
                      [
                        _vm._l(scope.row.deadlines, function(deadline) {
                          return _c("div", { key: deadline.date }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("saasDateFormatted")(deadline.date)
                                )
                              )
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "#7f868f" } }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Reste à solder : ")))
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("numberformatCurrency")(
                                    deadline.remainingAmount
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c(
                          "strong",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "1 échéance",
                                    "%d échéances",
                                    scope.row.deadlines.length,
                                    scope.row.deadlines.length
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.actions.reconcile"),
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { disabled: scope.row.isReconciled },
                        on: {
                          change: function($event) {
                            _vm.updateStore(
                              scope.row.storeId,
                              scope.row.payid,
                              _vm.deadlineIds(scope.row.deadlines),
                              $event
                            )
                          }
                        },
                        model: {
                          value: scope.row.isChecked,
                          callback: function($$v) {
                            _vm.$set(scope.row, "isChecked", $$v)
                          },
                          expression: "scope.row.isChecked"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Rapproché")) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.paymentsToAdd.length > 0,
              expression: "paymentsToAdd.length > 0"
            }
          ],
          class: {
            "el-table--disable-row-hover br": true,
            "b-1": !_vm.paymentsToDisplay.length,
            "bl-1 br-1 bb-1 br-top-0": _vm.paymentsToDisplay.length > 0
          },
          staticStyle: { width: "100%" },
          attrs: { data: _vm.paymentsToAdd, "row-key": _vm.rowKeyNewPayment }
        },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date"), width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("saasDateFormatted")(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.reference") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t.__("common.labels.a_reference"),
                        disabled: scope.row.isLocked
                      },
                      model: {
                        value: scope.row.ref,
                        callback: function($$v) {
                          _vm.$set(scope.row, "ref", $$v)
                        },
                        expression: "scope.row.ref"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.labels.payment_amount"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("input-number", {
                      attrs: {
                        precision: _vm.numberFormat.precision,
                        "separator-decimal": _vm.numberFormat.decimal,
                        "separator-thousand": _vm.numberFormat.thousand,
                        disabled: scope.row.isLocked,
                        controls: false,
                        placeholder: _vm.$t.__("common.labels.amount"),
                        size: "small",
                        min: 0.01,
                        max: _vm.dueAmountDeadline
                      },
                      model: {
                        value: scope.row.amount,
                        callback: function($$v) {
                          _vm.$set(scope.row, "amount", $$v)
                        },
                        expression: "scope.row.amount"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "bankreconciliation.DeadlineListing.related_deadline"
              ),
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          placeholder: _vm.$t.__(
                            "bankreconciliation.DeadlineListing.link_deadline"
                          )
                        },
                        on: { change: _vm.updateAmount },
                        model: {
                          value: scope.row.deadlineIds,
                          callback: function($$v) {
                            _vm.$set(scope.row, "deadlineIds", $$v)
                          },
                          expression: "scope.row.deadlineIds"
                        }
                      },
                      _vm._l(_vm.onlyRemaining, function(deadline) {
                        return _c(
                          "el-option",
                          {
                            key: deadline.deadlineid,
                            attrs: {
                              label: _vm._f("saasDateFormatted")(deadline.date),
                              value: deadline.deadlineid
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("saasDateFormatted")(deadline.date)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "#7f868f" } }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Reste à solder : ")) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("numberformatCurrency")(
                                    deadline.remainingAmount
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__("common.actions.reconcile"),
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("i", {
                      staticClass: "icon-trash link",
                      staticStyle: { float: "right" },
                      on: {
                        click: function($event) {
                          return _vm.removeSelectedLine(scope.row.id)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("rb-new-payment-deadline-checkbox", {
                      attrs: {
                        default: false,
                        document: _vm.document,
                        reference: scope.row.ref,
                        amount: scope.row.amount,
                        deadlines: _vm.getDeadlines(scope.row.deadlineIds)
                      },
                      on: {
                        "new-payment-confirmed": function($event) {
                          return _vm.removeSelectedLine()
                        }
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "aright" },
        [
          _vm.canAddPayment
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "common.actions.add_and_reconcile__new_payment"
                  ),
                  type: "tertiary"
                },
                on: { click: _vm.addNewPayment }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }